var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs6":"","sm5":""}},[_c('v-text-field',{attrs:{"label":"Valor do Boleto","persistent-hint":"","single-line":"","type":"number","step":"0.01","prefix":"R$"},model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }